!function($) {

  // Add custom JavasScript here
  // --------------------------
  // Document ready
  $(function() {
    $('select.cf-country-picker').on('change', function (e) {
      var optionSelected = $("option:selected", this);
      var valueSelected = this.value;
      $('.cf-country-flag-emoji').text(valueSelected);
      var textSelected = $("option:selected").text();
      var textSelected1 = textSelected.split('(');
      var textSelected1 = textSelected1[1].split(')');
      $('#Phone').attr('data-value',textSelected1[0]);
    });

    $('#Phone').on('click', function () {
	  var get_val = $(this).attr('data-value');
      $(this).val(get_val + ' ');
    });
    
    $('#create_customer .button.submit_button').on('click',function(e){
      var x = true;
      
      $('.err-msg').remove();
      
      var fn = $('#first_name');
      var ln = $('#last_name');
      var em = $('#email');
      var cmem = $('#confirmation_email');
      var ps = $('#password');
      var cm = $('#Company');
      var add1 = $('#Address1');
      var city = $('#City');
      var zip = $('#Zip');
      var pn = $('#Phone');
      var taxoptout = $('#taxoptout');

      if(fn.val().trim() == ''){
        fn.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        fn.parent().find('.err-msg').remove();
      }
      
      if(ln.val().trim() == ''){
        ln.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        ln.parent().find('.err-msg').remove();
      }
      
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if(em.val().trim() == '' || !regex.test(em.val())) {
        em.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        em.parent().find('.err-msg').remove();
        
        if(em.val().trim() != cmem.val().trim()){
          cmem.parent().append('<p class="err-msg">Must match email</p>');
          x = false;
        } else {
          cmem.parent().find('.err-msg').remove();
        }

      }
      
      if(ps.val().trim() == ''){
        ps.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        ps.parent().find('.err-msg').remove();
      }
      
      if(cm.val().trim() == ''){
        cm.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        cm.parent().find('.err-msg').remove();
      }
      
      if(add1.val().trim() == ''){
        add1.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        add1.parent().find('.err-msg').remove();
      }
      
      if(city.val().trim() == ''){
        city.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        city.parent().find('.err-msg').remove();
      }
      
      if(zip.val().trim() == ''){
        zip.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        zip.parent().find('.err-msg').remove();
      }

      if(pn.val().trim() == ''){
        pn.parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      } else {
        pn.parent().find('.err-msg').remove();
      }

      if ($(taxoptout).is(':checked')) {
        taxoptout.parent().parent().find('.err-msg').remove();
      } else {
        taxoptout.parent().parent().append('<p class="err-msg">Must not be blank</p>');
        x = false;
      }

      if(x==false) {
        return false;
      }
    });
    
  });

}(jQuery);